import React from 'react';
import { Typography, Breadcrumbs } from '@mui/material';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import FadeIn from 'react-fade-in';
import baseStyles from '../Common/styles';

import banner from '../assets_2026/seasonal_page_Q4_2025_banner.png';
import continuumImg from '../assets_2026/seasonal_page_Q4_2025_continuum_btn.png';
import playgroundImg from '../assets_2026/seasonal_page_Q4_2025_playground_btn.png';
import shadowLineImg from '../assets_2026/seasonal_page_Q4_2025_shadowline_btn.png';

const useStyles = makeStyles((theme) => ({
    ...baseStyles(theme),
    breadcrumbs: {
        margin: '20px 0',
    },
    banner: {
        width: '100%',
        height: 'auto',
        display: 'block',
        marginBottom: '30px',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '0',
        marginBottom: '60px',
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr',
        },
    },
    column: {
        borderRight: `1px solid ${theme.palette.divider}`,
        [theme.breakpoints.down('sm')]: {
            borderRight: 'none',
            borderBottom: `1px solid ${theme.palette.divider}`,
        },
        '&:last-child': {
            borderRight: 'none',
            [theme.breakpoints.down('sm')]: {
                borderBottom: 'none',
            },
        },
    },
    columnImage: {
        width: '100%',
        height: 'auto',
        display: 'block',
    },
    columnText: {
        padding: '20px',
    },
    columnTitle: {
        fontWeight: 700,
        textTransform: 'uppercase',
        marginBottom: '10px',
    },
}));

const LINES = [
    {
        key: 'continuum',
        title: 'Continuum',
        image: continuumImg,
        description: 'As lines between work & life continue to blur, Continuum explores the expression of sporty aesthetic on tailored elements. Creating layers of individuality, practicality and authenticity.',
    },
    {
        key: 'playground',
        title: 'Playground',
        image: playgroundImg,
        description: 'As desire to escape the peace of life grows, nature provides the escape to play and recharge. Playground explores the intersection of earth and self, grounded in comfort and functionality.',
    },
    {
        key: 'shadow-line',
        title: 'Shadow-Line',
        image: shadowLineImg,
        description: 'As consumers seek meaning over materialism, Shadow-Line embraces the duality of softness and hardness. Details carry emotional undertones and hold space for introspection and protection.',
    },
];

export default function Q4Collection2025() {
    const classes = useStyles();

    return (
        <FadeIn>
            <div className={classes.root}>
                <Breadcrumbs className={classes.breadcrumbs} aria-label="breadcrumb">
                    <Link color="inherit" component={RouterLink} to="/">JML Home</Link>
                    <Link color="inherit" component={RouterLink} to="/seasonal-collection">Seasonal Collection</Link>
                    <Link color="inherit" component={RouterLink} to="/seasonal-collection/2025">2025 Seasonal Collection</Link>
                    <Typography color="primary">Q4 2025</Typography>
                </Breadcrumbs>

                <img src={banner} alt="Q4 2025 Collection" className={classes.banner} />

                <div className={classes.grid}>
                    {LINES.map((line) => (
                        <div key={line.key} className={classes.column}>
                            <img src={line.image} alt={line.title} className={classes.columnImage} />
                            <div className={classes.columnText}>
                                <Typography variant="subtitle1" className={classes.columnTitle}>{line.title}</Typography>
                                <Typography variant="body2">{line.description}</Typography>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </FadeIn>
    );
}
